export default "__VITE_ASSET__BjiMDyZc__"